import { render, staticRenderFns } from "./movie-item.vue?vue&type=template&id=eff33786&scoped=true"
import script from "./movie-item.vue?vue&type=script&lang=js"
export * from "./movie-item.vue?vue&type=script&lang=js"
import style0 from "./movie-item.vue?vue&type=style&index=0&id=eff33786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff33786",
  null
  
)

export default component.exports